/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_DescriptionInputs */

const en_terms_description = /** @type {(inputs: Terms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON terms of service. Read our terms for using the free online JSON tools.`)
};

const ko_terms_description = /** @type {(inputs: Terms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON 이용약관. 무료 온라인 JSON 도구 사용 약관을 읽어보세요.`)
};

const ja_terms_description = /** @type {(inputs: Terms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONの利用規約。無料オンラインJSONツールの利用規約をお読みください。`)
};

/**
* | output |
* | --- |
* | "PureJSON terms of service. Read our terms for using the free online JSON tools." |
*
* @param {Terms_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_description = /** @type {((inputs?: Terms_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_description(inputs)
	if (locale === "ko") return ko_terms_description(inputs)
	return ja_terms_description(inputs)
});